<template>
  <li class="nav-item nav-search">

    <!-- Icon -->
    <a
      href="javascript:void(0)"
      class="nav-link nav-link-search"
      @click="showSearchBar = true"
    >
      <feather-icon
        icon="SearchIcon"
        size="21"
      />
    </a>

    <!-- Input -->
    <div
      class="search-input"
      :class="{'open': showSearchBar}"
    >
      <div class="search-input-icon">
        <feather-icon icon="SearchIcon" />
      </div>
      <b-form-input
        v-if="showSearchBar"
        v-model="searchQuery"
        placeholder="Launcher Id"
        autofocus
        autocomplete="off"
        @keyup.esc="showSearchBar = false; resetsearchQuery()"
        @keyup.enter="suggestionSelected"
        @blur.stop="showSearchBar = false; resetsearchQuery()"
      />
      <div
        class="search-input-close"
        @click="showSearchBar = false;"
      >
        <feather-icon icon="XIcon" />
      </div>
    </div>
  </li>
</template>

<script>
import {BFormInput} from 'bootstrap-vue'
import {ref} from '@vue/composition-api'
import useAutoSuggest from "@core/components/app-auto-suggest/useAutoSuggest";
import searchAndBookmarkData from "@core/layouts/components/app-navbar/search-and-bookmark-data";
import '@/libs/toastification'

export default {
  components: {
    BFormInput
  },
  data() {
    return {
      searchQuery: undefined,
    }
  },
  methods: {
    suggestionSelected() {
      if (this.searchQuery == null || this.searchQuery == undefined || this.searchQuery == "") {
        this.$toast.error("Launcher Id cannot be empty");
        return
      }
      if (this.searchQuery.length > 64) {
        this.$toast.error("Launcher Id max length 64");
        return
      }
      this.$emit('searchLauncherId', this.searchQuery);
    }
  },
  setup() {
    const showSearchBar = ref(false)
    const {
      resetsearchQuery,
      filteredData,
    } = useAutoSuggest({data: searchAndBookmarkData, searchLimit: 4})

    const currentSelected = ref(-1)

    return {
      showSearchBar,
      searchAndBookmarkData,
      currentSelected,
      resetsearchQuery,
      filteredData,
    }
  },
}
</script>

<style lang="scss" scoped>
@import '~@core/scss/base/bootstrap-extended/include';
@import '~@core/scss/base/components/variables-dark';

ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

p {
  margin: 0;
}

.suggestion-group-title {
  font-weight: 500;
  padding: .75rem 1rem .25rem;
}

.suggestion-group-suggestion {
  padding: .75rem 1rem
}

.suggestion-current-selected {
  background-color: $body-bg;

  .dark-layout & {
    background-color: $theme-dark-body-bg;
  }
}
</style>
